/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_TitleInputs */

const en_history_title = /** @type {(inputs: History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cooked`)
};

const de_history_title = /** @type {(inputs: History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gekocht`)
};

/**
* | output |
* | --- |
* | "Cooked" |
*
* @param {History_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const history_title = /** @type {((inputs?: History_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_history_title(inputs)
	return en_history_title(inputs)
});